// @flow

import styled from 'styled-components'

const PreWrap = styled.div`
  word-wrap: break-word;
  white-space: pre-wrap;
`

export default PreWrap



// WEBPACK FOOTER //
// ./src/components/atoms/PreWrap/index.jsx